import { RequireSubmissionProvided } from "../../../../../wrappers/requireSubmission";
import { useEffect, useMemo } from "react";
import { SubmissionData2026Sedera, SubmissionData2026SederaAddon, isSubmissionData2026, updateSubmission } from "../../../../../reduxToolkit/submissionsSlice";
import { useAppDispatch } from "../../../../../hooks/reduxToolkit";
import { SubmissionInstructionsSedera2026 } from "./submissionInstructionsSedera2026";

export interface SubmitToSedera2026Props extends RequireSubmissionProvided {
}

export function SubmitToSedera2026({ submission }: SubmitToSedera2026Props) {
  const dispatch = useAppDispatch()
  const isAddon = submission.submission_type === 'Sedera-addon'

  const data = useMemo((): SubmissionData2026Sedera | SubmissionData2026SederaAddon => {
    if (isSubmissionData2026(submission.data) && (submission.data.type === 'Sedera' || submission.data.type === 'Sedera-addon')) {
      return submission.data
    }

    return {
      _version: '2026-01-01',
      type: isAddon ? 'Sedera-addon' : 'Sedera',
      instructionsShown: true,
    }
  }, [submission.data, isAddon])

  useEffect(() => {
    if (!submission.data || !isSubmissionData2026(submission.data)) {
      const now = new Date().toISOString()
      dispatch(updateSubmission({
        id: submission.id,
        data: {
          ...data,
          instructionsShown: true,
        },
        updated_at: now,
      }))
    }
  }, [submission.id, submission.data, data, dispatch])

  return <SubmissionInstructionsSedera2026 submission={submission} data={data} />
}
